import React, {FC, Suspense} from 'react';
// DO NOT DELETE
import i18n from "../i18n";
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import Main from "../pages"
import Patient from "../pages/patient"
import Assay from "../pages/assay";
import Biobank from "../pages/biobank";
import Header from "../components/header";
import Footer from "../components/footer";
import '../App.css'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App: FC = () => {
    return (
        <div className="App container my-5">
            <ToastContainer position="top-right" autoClose={5000} />
            <Header/>
            <Suspense fallback={null}>
                <Router>
                    <Routes>
                        <Route path="/" element={<Main/>}/>
                        <Route path="patients" element={<Patient/>}/>
                        <Route path="assays" element={<Assay/>}/>
                        <Route path="biobanks" element={<Biobank/>}/>
                    </Routes>
                </Router>
            </Suspense>

            <Footer/>

        </div>
    );
}

export default App;